import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useCart } from '../context/CartContext';
import { Button } from '../components/ui/button';
import { Trash2, Minus, Plus } from 'lucide-react';

const Cart = () => {
  const { items, remove, updateQty, subtotal, clear } = useCart();
  return (
    <>
      <Header />
      <main className="bg-black min-h-[60vh]">
        <div className="max-w-[1200px] mx-auto px-6 py-16">
          <h1 className="serif-italic gold-gradient-text text-5xl">Your Cart</h1>

          {items.length === 0 ? (
            <div className="mt-10 p-10 border border-zinc-900 rounded text-center">
              <p className="text-zinc-400">Your cart is empty.</p>
              <Link to="/shop"><Button className="btn-gold mt-6 px-8">Start shopping</Button></Link>
            </div>
          ) : (
            <div className="mt-10 grid lg:grid-cols-[1fr,360px] gap-10">
              <div className="space-y-4">
                {items.map((i) => (
                  <div key={i.id} className="flex gap-4 border border-zinc-900 rounded p-4 items-center">
                    <img src={i.image} alt={i.name} className="w-24 h-24 object-cover rounded" />
                    <div className="flex-1">
                      <h3 className="serif-italic text-zinc-100 text-lg">{i.name}</h3>
                      <p className="text-[#d4af37]">€{i.price.toFixed(2)}</p>
                    </div>
                    <div className="flex items-center border border-zinc-800 rounded">
                      <button className="px-2 py-1 text-zinc-300" onClick={() => updateQty(i.id, i.qty-1)}><Minus className="h-4 w-4" /></button>
                      <span className="px-3 text-zinc-100">{i.qty}</span>
                      <button className="px-2 py-1 text-zinc-300" onClick={() => updateQty(i.id, i.qty+1)}><Plus className="h-4 w-4" /></button>
                    </div>
                    <button onClick={() => remove(i.id)} aria-label="Remove" className="text-zinc-400 hover:text-red-500 ml-2"><Trash2 className="h-5 w-5" /></button>
                  </div>
                ))}
                <button onClick={clear} className="text-zinc-500 hover:text-[#d4af37] text-sm underline">Clear cart</button>
              </div>
              <aside className="border border-zinc-900 rounded p-6 h-fit bg-zinc-950">
                <h3 className="serif-italic text-2xl text-[#d4af37] mb-4">Order Summary</h3>
                <div className="flex justify-between text-zinc-300 mb-2"><span>Subtotal</span><span>€{subtotal.toFixed(2)}</span></div>
                <div className="flex justify-between text-zinc-500 text-sm mb-4"><span>Shipping</span><span>Calculated at checkout</span></div>
                <div className="border-t border-zinc-800 pt-4 flex justify-between text-zinc-100 text-lg"><span>Total</span><span className="text-[#d4af37]">€{subtotal.toFixed(2)}</span></div>
                <Link to="/checkout"><Button className="btn-gold w-full mt-6 h-12 tracking-wider uppercase">Checkout</Button></Link>
                <p className="text-xs text-zinc-500 mt-3 text-center">Pay with iDEAL, Card or Crypto. Merchant settles in BTC/ETH.</p>
              </aside>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Cart;
